ApiError = require 'network/api-error'
Util = require 'lib/util'
BillingFormUtil = require '../internal/billing-form-util'
CreditCardFormError = require '../internal/credit-card-form-error'
React = require 'react'
FormFields = require './internal/form-fields'
BraintreeGateway = require './internal/braintree-gateway'
Promise = require 'bluebird'
t = require('views/internal/recup-with-helpers')('credit_card')
f = require 'effing'
xtend = require 'xtend'
countries = require './internal/countries'
euCountries = require 'data/eu-countries'

module.exports = class extends React.Component
  displayName: 'CreditCardUpdateComponent'

  formFields: ['country', 'zipCode', 'taxId']
  requiredFields:
    country: /\S/
    zipCode: (value, { country }) ->
      (country != 'US' && country != 'CA' && country != 'PR') || BillingFormUtil.testZipCode(value, country)

  constructor: (props) ->
    super(props)

    @state = {
      errorField: ''
      submitting: false
      unknownError: ''
    }

  componentDidMount: ->
    @isStillMounted = true

  componentWillUmount: ->
    @isStillMounted = false

  render: t.renderable ->
    { onSubmit } = @props
    {
      errorField
      submitting
      unknownError
    } = @state

    localizedCountries = @getLocalizedCountries()

    renderForm = ({ controlledOpts, getData, setFormState, formState }) =>
      {
        country
        zipCode
      } = formState

      onSubmitClick = (e) =>
        @setState(submitting: true)

        getData()
        .then(onSubmit)
        .catch CreditCardFormError.InvalidField, ({ field }) =>
          if @isStillMounted
            @setState
              errorField: field
              submitting: false
        .catch CreditCardFormError.PostError, (error) =>
          if Util.isJsonString(error?.message)
            errorJSON = JSON.parse(error.message)
            errorField = BillingFormUtil.getErrorField(errorJSON?.error)
            if errorField && @isStillMounted
              @setState
                errorField: errorField
                submitting: false
          else
            if @isStillMounted
              @setState
                unknownError: error.message ? "error"
                submitting: false
        .catch ApiError, ({ message }) =>
          if @isStillMounted
            @setState
              unknownError: message ? "error"
              submitting: false
        .done()

      renderBraintree = ({ braintreeState, setBraintreeState }) =>
        {
          cardType
          gatewayFieldStatus
          gatewayFocusField
          gatewayLoaded
          niceCardType
        } = braintreeState

        @requiredFields.number = => !BillingFormUtil.isUnsupportedCardType cardType

        onCountryChange = (e) ->
          setFormState {
            country: e.target.value
            zipCode: ''
            taxId: ''
          }

        errorableTextInput = (stateKey, labelKey, errorLabelKey, attrs) ->
          isErrored = stateKey == errorField

          t.label ->
            t.format labelKey
            t.input xtend attrs, controlledOpts(stateKey),
              class: t.classify({ text: true, 'input-error': isErrored })
              type: 'text'
            if isErrored
              t.span '.u-form-error', ->
                t.format errorLabelKey

        t.div '.u-clearfix', ->
          t.form { @onSubmit, ref: 'form', key: 'credit-card-update-form' }, ->

            t.div '.credit-card-update-section.u-clearfix', ->
              gatewayField = ({ selector, labelKey, fieldType, isInvalid, formatError }) ->
                t.label ->
                  t.span "#{ selector }-label-text", ->
                    t.format labelKey

                  t.div ".iframe-input#{ selector }", class:
                    t.classify
                      disabled: !gatewayLoaded
                      focus: gatewayFocusField == fieldType
                      'input-error': isInvalid
                  if formatError? && isInvalid
                    t.span '.u-form-error', ->
                      formatError()

              t.div '.u-clearfix', ->
                t.div '.credit-card-form-number', ->
                  gatewayField
                    selector: '.js-card-number'
                    labelKey: 'card-number'
                    fieldType: 'number'
                    isInvalid: gatewayFieldStatus['number'] == 'invalid' || BillingFormUtil.isUnsupportedCardType cardType
                    formatError: BillingFormUtil.getCardErrorFormatter cardType, niceCardType


                t.div '.credit-card-expiration-date', ->
                  gatewayField
                    selector: '.js-expiration-date'
                    labelKey: 'expiration'
                    fieldType: 'expirationDate'
                    isInvalid: gatewayFieldStatus['expirationDate'] == 'invalid'
                    formatError: -> t.format 'please-provide-a-valid-expiration-date'

                t.div '.credit-card-form-cvv', ->
                  gatewayField
                    selector: '.js-cvv'
                    labelKey: 'cvv'
                    fieldType: 'cvv'
                    isInvalid: gatewayFieldStatus['cvv'] == 'invalid'
                    formatError: -> t.format BillingFormUtil.getCvvErrorKey(cardType)

              t.div '.credit-card-country', ->
                t.label ->
                  t.format 'country'
                  t.text ' '
                t.select xtend(controlledOpts('country'), onChange: onCountryChange, autoComplete: 'country'), ->
                  for [value, name] in localizedCountries
                    t.option { value }, -> t.text name
                  return

              if country == 'US' or country == 'CA' or country == 'PR'
                t.div '.credit-card-zip-code', ->
                  errorableTextInput 'zipCode', 'zip-postal-code', 'please-enter-a-valid-postal-code',
                    maxLength: '10'
                    size: '10'
                    autoComplete: 'postal-code'

              t.div class: t.classify({ 'tax-number': true, 'hide': !(euCountries.indexOf(country) != -1 || country == 'AU') }), ->
                t.label ->
                  isErrored = 'taxId' == errorField
                  t.format 'tax-number',
                    taxType: (if country == 'AU' then 'ABN' else 'VAT')
                  t.input xtend controlledOpts('taxId'),
                    class: t.classify({ text: true, 'input-error': isErrored })
                    type: 'text'
                  if isErrored
                    t.span '.u-form-error', ->
                      t.format 'please-enter-a-valid-tax-number'


          if unknownError
            t.p '.u-form-error', ->
              t.text unknownError
          t.div ->
            t.button '.primary', {
              onClick: onSubmitClick
              disabled: submitting
              class: t.classify(disabled: submitting)
            }, ->
              t.format 'save'

      t.tag BraintreeGateway, {
        ref: (braintree) =>
          @braintree = braintree
        render: renderBraintree
      }

    t.tag FormFields, {
      render: renderForm
      ref: (formFieldsRef) => @formFieldsRef = formFieldsRef
      @formFields
      @requiredFields
      initialState: {
        country: countries.special[0][0]
        taxId: ''
        zipCode: ''
      }
      getAsyncData: => @braintree.getAsyncData()
    }

  getLocalizedCountries: ->
    localizedSpecialCountries = countries.special.map(BillingFormUtil.localizeCountry)
    localizedUnlovedCountries = countries.unloved
    .map BillingFormUtil.localizeCountry
    .sort ([aKey, aName], [bKey, bName]) -> aName.localeCompare(bName)

    localizedSpecialCountries.concat(localizedUnlovedCountries)

  onSubmit = (e) ->
    e.preventDefault()



// WEBPACK FOOTER //
// ./app/scripts/views/billing/form-sections/credit-card-update-component.coffee